import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container"];

  connect() {
    this.snapTimeout = null;
  }

  disconnect() {
    if (this.snapTimeout) {
      clearTimeout(this.snapTimeout);
    }
  }

  scrollLeft() {
    this.scrollToCard("left");
  }

  scrollRight() {
    this.scrollToCard("right");
  }

  scrollToCard(direction) {
    if (!this.hasContainerTarget) return;

    const container = this.containerTarget;
    const cards = Array.from(container.children).filter(
      (child) => child.nodeType === 1 && child.classList.contains("snap-center")
    );

    if (cards.length === 0) return;

    const containerWidth = container.offsetWidth;
    const currentScroll = container.scrollLeft;

    // Calculate the absolute position of each card relative to the container's scrolled canvas
    const cardPositions = cards.map((card) => {
      const cardOffset = container.scrollLeft + card.getBoundingClientRect().left - container.getBoundingClientRect().left;
      const cardWidth = card.getBoundingClientRect().width;
      // Because cards are centered (snap-center), we calculate the scroll position that centers the card
      const snapPosition = cardOffset - (containerWidth - cardWidth) / 2;
      return {
        leftEdge: cardOffset,
        snapPosition: Math.max(0, snapPosition)
      };
    });

    let targetScrollLeft = currentScroll;

    if (direction === "right") {
      // Find the first card whose center scroll position is greater than current scroll (+ margin for threshold)
      const nextCard = cardPositions.find(
        (pos) => pos.snapPosition > currentScroll + 10
      );
      if (nextCard) {
        targetScrollLeft = nextCard.snapPosition;
      } else {
        // If we're near the end, just scroll to the very end
        targetScrollLeft = container.scrollWidth - containerWidth;
      }
    } else {
      // Find the last card whose center scroll position is less than current scroll (- margin for threshold)
      const prevCard = [...cardPositions]
        .reverse()
        .find((pos) => pos.snapPosition < currentScroll - 10);
      if (prevCard) {
        targetScrollLeft = prevCard.snapPosition;
      } else {
        // If we're near the start, scroll to 0
        targetScrollLeft = 0;
      }
    }

    // Clear any pending re-enable timeout
    if (this.snapTimeout) {
      clearTimeout(this.snapTimeout);
    }

    // Temporarily disable scroll snapping to prevent iOS Safari from conflicting/rebounding
    container.style.scrollSnapType = "none";

    container.scrollTo({
      left: targetScrollLeft,
      behavior: "smooth",
    });

    // Re-enable scroll snap after the smooth scroll finishes
    this.snapTimeout = setTimeout(() => {
      container.style.scrollSnapType = "";
      this.snapTimeout = null;
    }, 500);
  }
}

